/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.assistant.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/assistant/v4/preferences.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as wisetime_user_assistant_v4_preferences_pb from '../../../../wisetime/user/assistant/v4/preferences_pb';


export class NarratePreferencesServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetDefaultNarratePreferences = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.NarratePreferencesService/GetDefaultNarratePreferences',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    wisetime_user_assistant_v4_preferences_pb.NarratePreferences,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_preferences_pb.NarratePreferences.deserializeBinary
  );

  getDefaultNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_preferences_pb.NarratePreferences>;

  getDefaultNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.NarratePreferences) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_preferences_pb.NarratePreferences>;

  getDefaultNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.NarratePreferences) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.NarratePreferencesService/GetDefaultNarratePreferences',
        request,
        metadata || {},
        this.methodDescriptorGetDefaultNarratePreferences,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.NarratePreferencesService/GetDefaultNarratePreferences',
    request,
    metadata || {},
    this.methodDescriptorGetDefaultNarratePreferences);
  }

  methodDescriptorGetNarratePreferences = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.NarratePreferencesService/GetNarratePreferences',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    wisetime_user_assistant_v4_preferences_pb.NarratePreferences,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_preferences_pb.NarratePreferences.deserializeBinary
  );

  getNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_preferences_pb.NarratePreferences>;

  getNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.NarratePreferences) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_preferences_pb.NarratePreferences>;

  getNarratePreferences(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.NarratePreferences) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.NarratePreferencesService/GetNarratePreferences',
        request,
        metadata || {},
        this.methodDescriptorGetNarratePreferences,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.NarratePreferencesService/GetNarratePreferences',
    request,
    metadata || {},
    this.methodDescriptorGetNarratePreferences);
  }

  methodDescriptorSetNarratePreferences = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.NarratePreferencesService/SetNarratePreferences',
    grpcWeb.MethodType.UNARY,
    wisetime_user_assistant_v4_preferences_pb.SetNarratePreferencesRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_user_assistant_v4_preferences_pb.SetNarratePreferencesRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  setNarratePreferences(
    request: wisetime_user_assistant_v4_preferences_pb.SetNarratePreferencesRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  setNarratePreferences(
    request: wisetime_user_assistant_v4_preferences_pb.SetNarratePreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  setNarratePreferences(
    request: wisetime_user_assistant_v4_preferences_pb.SetNarratePreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.NarratePreferencesService/SetNarratePreferences',
        request,
        metadata || {},
        this.methodDescriptorSetNarratePreferences,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.NarratePreferencesService/SetNarratePreferences',
    request,
    metadata || {},
    this.methodDescriptorSetNarratePreferences);
  }

  methodDescriptorListTrainingGroups = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.NarratePreferencesService/ListTrainingGroups',
    grpcWeb.MethodType.UNARY,
    wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsRequest,
    wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse,
    (request: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse.deserializeBinary
  );

  listTrainingGroups(
    request: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse>;

  listTrainingGroups(
    request: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse>;

  listTrainingGroups(
    request: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.ListTrainingGroupsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.NarratePreferencesService/ListTrainingGroups',
        request,
        metadata || {},
        this.methodDescriptorListTrainingGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.NarratePreferencesService/ListTrainingGroups',
    request,
    metadata || {},
    this.methodDescriptorListTrainingGroups);
  }

  methodDescriptorGetTrainingNarrative = new grpcWeb.MethodDescriptor(
    '/wisetime.user.assistant.v4.NarratePreferencesService/GetTrainingNarrative',
    grpcWeb.MethodType.UNARY,
    wisetime_user_assistant_v4_preferences_pb.GetTrainingNarrativeRequest,
    wisetime_user_assistant_v4_preferences_pb.TrainingNarrative,
    (request: wisetime_user_assistant_v4_preferences_pb.GetTrainingNarrativeRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_assistant_v4_preferences_pb.TrainingNarrative.deserializeBinary
  );

  getTrainingNarrative(
    request: wisetime_user_assistant_v4_preferences_pb.GetTrainingNarrativeRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_assistant_v4_preferences_pb.TrainingNarrative>;

  getTrainingNarrative(
    request: wisetime_user_assistant_v4_preferences_pb.GetTrainingNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.TrainingNarrative) => void): grpcWeb.ClientReadableStream<wisetime_user_assistant_v4_preferences_pb.TrainingNarrative>;

  getTrainingNarrative(
    request: wisetime_user_assistant_v4_preferences_pb.GetTrainingNarrativeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_assistant_v4_preferences_pb.TrainingNarrative) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.assistant.v4.NarratePreferencesService/GetTrainingNarrative',
        request,
        metadata || {},
        this.methodDescriptorGetTrainingNarrative,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.assistant.v4.NarratePreferencesService/GetTrainingNarrative',
    request,
    metadata || {},
    this.methodDescriptorGetTrainingNarrative);
  }

}

